import { useState } from "react";
import { useLocation, useParams } from "react-router-dom";

import { Box, IconButton, Button } from "@mui/material";
import { AutoAwesome as AutoAwesomeIcon } from "@mui/icons-material";

import { LeftPanelCloseIcon, LeftPanelOpenIcon } from "../../assets/icons";
import { Logo, SkewbLogo } from "../../assets";
import ThemeToggle from "./ThemeToggle";
import { UserMenu } from "./UserMenu";
import { ProjectSwitcher } from "./ProjectSwitcher";
import { AiChatDrawer } from "../../features/aiChat";
import Breadcrumb from "./BreadcrumbsComponent";

interface AppHeaderProps {
  onMenu: () => void;
  drawerOpen: boolean;
  title: string;
  currentProjectTitle?: string;
}

export const AppHeader = ({ onMenu, drawerOpen, title }: AppHeaderProps) => {

  const location = useLocation();
  const { projectId } = useParams();
  const [aiChatOpen, setAiChatOpen] = useState(false);

  const isProjectDetailsPage = location.pathname.includes("/project/") && projectId;

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          px: 3,
          py: 1,
          position: "relative",
          zIndex: 10,
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        {location.pathname !== "/dashboard" && (
          <IconButton edge="start" onClick={onMenu} sx={{ mr: 2 }}>
            {drawerOpen ? <LeftPanelCloseIcon /> : <LeftPanelOpenIcon />}
          </IconButton>
        )}
        <Box sx={{ flexGrow: 1, display: "flex", alignItems: 'center', gap: 5 }}>
          <Breadcrumb />
          {isProjectDetailsPage && (
            <ProjectSwitcher currentProjectId={projectId!} />
          )}
        </Box>
        <Box display="flex" alignItems="center" gap={1}>
          <Button
            variant="outlined"
            onClick={() => setAiChatOpen(true)}
            sx={{ textTransform: "none", display: "none" }}
            startIcon={<AutoAwesomeIcon />}
          >
            Ask CapAI
          </Button>
          <UserMenu />
          <ThemeToggle />
          <Box
            sx={{
              maxWidth: "112px",
              alignItems: "center",
              justifyContent: "center",
              mx: 1,
              display: { xs: "none", md: "flex" },
            }}
          >
            <Logo maxWidth="112px" maxHeight="30px" />
          </Box>
          <Box
            sx={{
              order: { xs: 1, md: 2 },
              color: "text.secondary",
              maxWidth: "100px",
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <SkewbLogo />
          </Box>
        </Box>
      </Box>
      <AiChatDrawer open={aiChatOpen} onClose={() => setAiChatOpen(false)} />
    </>
  );

};